import type { EditorState, BaseLayerData } from './types';

const ROOT_COMP_ID = '__root__';

export function createEditorState(
  overrides?: {
    canvas?: { width: number; height: number };
    duration?: number;
    frameRate?: number;
    name?: string;
  },
): EditorState {
  const width = overrides?.canvas?.width ?? 1920;
  const height = overrides?.canvas?.height ?? 1080;
  const duration = overrides?.duration ?? 10;
  const frameRate = overrides?.frameRate ?? 24;
  const name = overrides?.name ?? 'Untitled';

  const rootComp: BaseLayerData = {
    id: ROOT_COMP_ID,
    type: 'composition',
    name,
    order: 0,
    parentId: null, // root has no parent
    x: 0,
    y: 0,
    width,
    height,
    anchorX: 0,
    anchorY: 0,
    rotation: 0,
    scaleX: 1,
    scaleY: 1,
    opacity: 1,
    shadowColor: 'transparent',
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowOpacity: 0,
    startTime: 0,
    endTime: duration,
    visible: true,
    locked: false,
    effects: {},
    // Composition-specific
    duration,
    frameRate,
    background: '',
  };

  return {
    layers: { [ROOT_COMP_ID]: rootComp },
    rootLayerId: ROOT_COMP_ID,
    selectedIds: new Set(),
    primarySelectedId: null,
    playheadTime: 0,
    isPlaying: false,
  };
}

export function cloneState(state: EditorState): EditorState {
  return {
    ...state,
    layers: { ...state.layers },
    selectedIds: new Set(state.selectedIds),
  };
}

export { ROOT_COMP_ID };
